import { client } from "./api";

export async function getTenantConfig() {
  const api = client();
  const response = await api.get("tenants/config");

  return response.data;
}

export interface ITenantConfig {
  color?: string;
  imgURL?: string;
  waterMark?: string;
  // valor maximo de kilometros, antes que seja cobrado valor adicional por km
  maximumKilometerBeforeAdditionaKmValues?: number;
  // valor maximo de horas, antes que seja cobrado valor adicional por hora
  maximumHoursBeforeAdditionaHourValues?: number;
}

export async function changeTenantConfig(config: ITenantConfig) {
  const api = client();
  await api.patch("tenants/config", config);
}

// tenants/verify
export async function getTenantByCode(code: string) {
  const api = client();

  try {
    const response = await api.post("tenants/verify", { code });
    return response.data;
  } catch (err) {
    return { status: false };
  }
}
